import { performanceDashboard } from "./performanceDashboard";
import { revenueTrafficOpportunity } from "./revenueTrafficOpportunity";
import { uxDashboard } from "./uxDashboard";
import { competitorPerformance } from "./competitorPerformance";
// import { howCustomersSearch } from "./howCustomersSearch";
import { featureFormat } from "./featureFormat";
import { useReportContext } from "context/ReportContext";
import { useEffect, useState } from "react";

function findBlockRecursive(arr, id) {
  for (let i = 0; i < arr.length; i++) {
    const item = arr[i];

    if (item.id === id) {
      return item;
    }

    // Search multiblocks
    if (item?.multiBlock?.items) {
      const result = findBlockRecursive(item.multiBlock.items, id);
      if (result) {
        return result;
      }
    }
  }

  return null;
}

export const ReportOverview = (props) => {
  const { report } = useReportContext();
  let performanceDashboardBlock = performanceDashboard(props).find(
    (section) => section.id === "pd_traffic_opps"
  );
  performanceDashboardBlock.chartBlock.description = null;

  const revenueTrafficOpportunityBlock = findBlockRecursive(
    revenueTrafficOpportunity(props),
    "rto_traffic_category"
  );
  revenueTrafficOpportunityBlock.chartBlock.description = null;

  const uxDashboardBlock = uxDashboard(props).find(
    (section) => section.id === "ux_category_tbe"
  );

  const competitorPerformanceBlock = competitorPerformance(props).find(
    (section) => section.id === "cp_traffic"
  );
  competitorPerformanceBlock.chartBlock.description = null;

  const featureFormatBlock = featureFormat(props).find(
    (section) => section.id === "ff_type"
  );
  featureFormatBlock.chartBlock.description = null;

  // const overviewSections = [
  //   {
  //     headingBlock: {
  //       title: "Performance Dashboard Overview",
  //     },
  //   },
  //   {
  //     paragraphBlock: {
  //       text: "Breaking out the biggest opportunities from a revenue and rankings perspective.",
  //     },
  //   },
  //   {
  //     ...performanceDashboardBlock,
  //     className: "primary-pink",
  //   },

  //   {
  //     headingBlock: {
  //       title: "Revenue & Traffic Overview",
  //     },
  //   },
  //   {
  //     paragraphBlock: {
  //       text: "Identifying the biggest traffic & revenue opportunities by looking at position 1, top 3 & top 5.",
  //     },
  //   },
  //   {
  //     ...revenueTrafficOpportunityBlock,
  //     chartBlock: {
  //       ...revenueTrafficOpportunityBlock.chartBlock,
  //       container: true,
  //     },
  //   },

  //   {
  //     headingBlock: {
  //       title: "UX Dashboard Overview",
  //     },
  //   },
  //   {
  //     paragraphBlock: {
  //       text: "Creating a more efficient and profitable user journey.",
  //     },
  //   },
  //   {
  //     ...uxDashboardBlock,
  //     className: "primary-turquoise",
  //   },

  //   {
  //     headingBlock: {
  //       title: "Competitor Performance Overview",
  //     },
  //   },
  //   {
  //     paragraphBlock: {
  //       text: "How your site is ranking compared to competitors and looks at the traffic/revenue breakdown to identify who is winning across the keyword universe.",
  //     },
  //   },
  //   {
  //     ...competitorPerformanceBlock,
  //     className: "primary-yellow",
  //   },

  //   {
  //     headingBlock: {
  //       title: "Feature Format Overview",
  //     },
  //   },
  //   {
  //     paragraphBlock: {
  //       text: "What SERP features are appearing on Google and who are owning these SERP features.",
  //     },
  //   },
  //   {
  //     ...featureFormatBlock,
  //     className: "primary-green",
  //   },
  // ];

  const performanceDashboardSections = [
    {
      headingBlock: {
        title: "Performance Dashboard Overview",
        description: "",
      },
    },
    {
      paragraphBlock: {
        text: "This section identifies the biggest opportunities to increase website traffic by showing which product categories have the highest potential for growth. The numbers represent estimated additional visitors that could be attracted annually through improved search engine optimization. The categories at the top of this list show the largest opportunities, indicating where marketing efforts should be focused to maximize return on investment and drive the most significant traffic increases.",
      },
    },
    {
      ...performanceDashboardBlock,
      className: "primary-pink",
    },
  ];
  const revenueTrafficOpportunitySections = [
    {
      headingBlock: {
        title: "Revenue & Traffic Overview",
      },
    },
    {
      paragraphBlock: {
        text: `This view compares current website performance against the total market opportunity for the top 5 product categories. The "Est. Current Clicks" shows how many visitors are currently being attracted, while "Yearly Traffic Gain in #1" shows the additional traffic available through improved search rankings. This comparison helps identify which strong-performing categories still have room for growth and which smaller categories offer proportionally large opportunities for improvement.`,
      },
    },
    {
      ...revenueTrafficOpportunityBlock,
      chartBlock: {
        ...revenueTrafficOpportunityBlock.chartBlock,
        container: true,
      },
    },
  ];
  const uxDashboardSections = [
    {
      headingBlock: {
        title: "UX Dashboard Overview",
      },
    },
    {
      paragraphBlock: {
        text: "Creating a more efficient and profitable user journey.",
      },
    },
    {
      ...uxDashboardBlock,
      className: "primary-turquoise",
    },
  ];
  const competitorPerformanceSections = [
    {
      headingBlock: {
        title: "Competitor Performance Overview",
      },
    },
    {
      paragraphBlock: {
        text: "This analysis shows how website traffic compares to main competitors in the market. The data reveals the current market position and identifies what portion of total available traffic is being captured versus competitors. This information helps understand competitive standing and reveals opportunities to gain market share through improved digital marketing strategies and search engine optimization.",
      },
    },
    {
      ...competitorPerformanceBlock,
      className: "primary-yellow",
    },
  ];
  const featureFormatSections = [
    {
      headingBlock: {
        title: "Feature Format Overview",
      },
    },
    {
      paragraphBlock: {
        text: "This section shows what types of special search result features the website appears in on Google. Different feature types like Image Carousel, Product listings, and People Also Ask represent various opportunities to capture more prominent positions in search results. Features with higher counts indicate current strengths, while those with lower participation represent opportunities for improvement to drive higher click-through rates.",
      },
    },
    {
      ...featureFormatBlock,
      className: "primary-green",
    },
  ];

  const [result, setResult] = useState([false]);

  useEffect(() => {
    if (report.sections) {
      setResult((prevResult) => {
        let updatedResult = [...prevResult];

        if (!report.sections.includes("pd_traffic_opps")) {
          updatedResult = [...updatedResult, ...performanceDashboardSections];
        }
        if (!report.sections.includes("rto_traffic_category")) {
          updatedResult = [
            ...updatedResult,
            ...revenueTrafficOpportunitySections,
          ];
        }
        if (!report.sections.includes("ux_category_tbe")) {
          updatedResult = [...updatedResult, ...uxDashboardSections];
        }
        if (!report.sections.includes("cp_traffic")) {
          updatedResult = [...updatedResult, ...competitorPerformanceSections];
        }
        if (!report.sections.includes("ff_type")) {
          updatedResult = [...updatedResult, ...featureFormatSections];
        }

        return updatedResult;
      });
    } else {
      setResult([
        ...performanceDashboardSections,
        ...revenueTrafficOpportunitySections,
        ...uxDashboardSections,
        ...competitorPerformanceSections,
        ...featureFormatSections,
      ]);
    }
  }, [report.sections]);
  return result;
};
